import { themeGet } from '@styled-system/theme-get'
import { ComponentProps } from 'react'
import styled, { css } from 'styled-components'
import {
  ColorProps,
  FlexboxProps,
  PositionProps,
  SpaceProps,
  TypographyProps,
  color,
  flexbox,
  position,
  space,
  typography,
} from 'styled-system'
import { ifProp } from 'styled-tools'

import { Icon } from '@hap/components'

interface SpanProps extends FlexboxProps, SpaceProps, ColorProps, TypographyProps {
  nowrap?: boolean
}

const headerCss = css`
  color: ${themeGet('colors.text')};
  margin: 0;
`

export const Heading = styled.h1<ColorProps>`
  font-weight: 800;
  font-size: 2em;
  ${headerCss}
  ${color}
`

export const SubHeading = styled.h2<ColorProps>`
  font-weight: 600;
  font-size: 18px;
  ${headerCss}
  ${color}
`

export const Paragraph = styled.p<TypographyProps & ColorProps>`
  font-size: 1em;
  margin: 0;
  max-width: fit-content;
  ${typography}
  ${color}
`

export const ErrorText = styled((props: ComponentProps<'span'>) => {
  return (
    <span {...props}>
      {!!props.children && (
        <>
          <Icon name="warning-diamond" weight="fill" />
          {props.children}
        </>
      )}
    </span>
  )
})`
  color: ${themeGet('colors.error-text')};
  display: flex;
  font-size: ${themeGet('fontSizes.small')};
  margin-top: 2px;
  align-items: center;
  gap: 0.25em;
  min-height: 1.5em;
  letter-spacing: -0.5px;
`

export const ReadOnlyText = styled.div<PositionProps & SpaceProps>`
  background-color: ${themeGet('colors.readonly-text-bg')};
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 10px;
  font-size: 20pt;
  color: ${themeGet('colors.text')};
  border: 1px solid ${themeGet('colors.border-color')};

  ${position}
  ${space}
`

export const CopyText = styled(ReadOnlyText)<TypographyProps>`
  font-family: Courier;
  font-size: 24pt;
  font-weight: 600;
  ${typography}
`

export const Span = styled.span<SpanProps>`
  ${flexbox}
  ${space}
  ${color}
  ${typography}

  ${ifProp('nowrap', 'white-space: nowrap;')}
`
